export const UPDATE_PRODUCT_PLAN = 'SAVING/UPDATE_PRODUCT_PLAN'
export const updateProductPlan = (planCode) => ({
  type: UPDATE_PRODUCT_PLAN,
  payload: planCode,
})
